// React
import React from 'react';
import PropTypes from 'prop-types';

// CYBS-UI
import { StructFlex, StructItem } from '@cybs-ui/components/lib/struct-flex';

// Styles
import css from './component.styles';

const KeyValuePair = ({
  dataTest,
  formatColon,
  label,
  value,
  isVertical,
  ...rest
}) => {
  const wrapperClass = theme => css(theme).wrapper;
  const labelCss = theme => css(theme).label;
  const valueCss = theme => css(theme).value;
  return (
    <StructFlex
      css={wrapperClass}
      data-test={`${dataTest}-cybsKeyValuePair`}
      direction={isVertical ? 'column' : 'row'}
      flex-wrap="wrap"
      {...rest}
    >
      {label && (
        <StructItem>
          <b css={labelCss}>{formatColon(label)}</b>
        </StructItem>
      )}
      {value && (
        <StructItem>
          {typeof value === 'string' ? <span css={valueCss}>{value}</span> : value}
        </StructItem>
      )}
    </StructFlex>
  );
};

KeyValuePair.propTypes = {
  /**
   * dataTest string for testing.
   */
  dataTest: PropTypes.string.isRequired,
  /**
   * Adds a colon to the key. This must be provided when using any language
   * where the colon is prepended (such as in RTL languages).
   */
  formatColon: PropTypes.func,
  /**
   * Determines if key value pair is vertical or horizontal.
   */
  isVertical: PropTypes.bool,
  /**
   * Label for key. Will be bolded.
   */
  label: PropTypes.string,
  /**
   * Value. Can be string or node.
   */
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};

KeyValuePair.defaultProps = {
  formatColon: key => (<>{key}:</>), // eslint-disable-line
  isVertical: false,
  label: '',
  value: ''
};

KeyValuePair.displayName = 'KeyValuePair';

export default KeyValuePair;
